<div class="modal-header">
    <h4 class="modal-title">{{ title }}</h4>
</div>
<form name="form" #form="ngForm">
    <div class="modal-body">
        <div class="row">
            <div class="col-12">
                <div class="form-group">
                    <label for="name">Name</label>
                    <input id="name" type="text" class="form-control" [(ngModel)]="target.name" name="name" required />
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-6">
                <div class="form-group">
                    <label for="goalLabel">Goal Label</label>
                    <input id="goalLabel" type="text" class="form-control" [(ngModel)]="target.goalLabel" name="goalLabel" required />
                </div>
            </div>
            <div class="col-6">
                <div class="form-group">
                    <label for="order">Order</label>
                    <input id="order" type="number" class="form-control" [(ngModel)]="target.order" name="order" />
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-4">
                <div class="form-group">
                    <label for="goalDirection">Goal Direction</label>
                    <wj-combo-box
                        id="goalDirection"
                        [(ngModel)]="target.goalDirection"
                        name="goalDirection"
                        [itemsSource]="goalDirectionList"
                        [displayMemberPath]="'display'"
                        [selectedValuePath]="'value'"
                    ></wj-combo-box>
                </div>
            </div>
            <div class="col-4">
                <div class="form-group">
                    <label for="goalValue">Goal Value</label>
                    <input id="goalValue" type="number" step="any" class="form-control" [(ngModel)]="target.goalValue" name="goalValue" />
                </div>
            </div>
            <div class="col-4">
                <div class="form-group">
                    <label for="goalValue2">Goal Value 2 (between)</label>
                    <input id="goalValue2" type="number" step="any" class="form-control" [(ngModel)]="target.goalValue2" name="goalValue2" />
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-6">
                <div class="form-group">
                    <label for="format">Format</label>
                    <wj-combo-box
                        id="format"
                        [(ngModel)]="target.format"
                        name="format"
                        [itemsSource]="formatList"
                        [displayMemberPath]="'display'"
                        [selectedValuePath]="'value'"
                    ></wj-combo-box>
                </div>
            </div>
            <div class="col-6">
                <div class="form-group">
                    <label for="isArchived">Archived</label>
                    <wj-combo-box
                        id="isArchived"
                        [(ngModel)]="target.isArchived"
                        name="isArchived"
                        [itemsSource]="boolList"
                        [displayMemberPath]="'display'"
                        [selectedValuePath]="'value'"
                    ></wj-combo-box>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-12">
                <div class="form-group">
                    <label for="hrGoalId">Source Metric</label>
                    @if (metricsLoaded) {
                        <wj-combo-box
                            id="hrGoalId"
                            #metricCombo
                            [(ngModel)]="target.hrGoalId"
                            name="hrGoalId"
                            [itemsSource]="metricList"
                            [displayMemberPath]="'display'"
                            [selectedValuePath]="'value'"
                            (initialized)="onMetricComboInitialized(metricCombo)"
                            (ngModelChange)="onMetricChanged()"
                        ></wj-combo-box>
                    } @else {
                        <input id="hrGoalId" type="text" class="form-control" disabled placeholder="Loading metrics..." />
                    }
                    <small class="form-text text-muted">Optional. When linked, quarterly values are computed from weekly scorecard data.</small>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-12">
                <div class="form-group">
                    <label for="calculatedSource">Calculated Source</label>
                    <wj-combo-box
                        id="calculatedSource"
                        [(ngModel)]="target.calculatedSource"
                        name="calculatedSource"
                        [itemsSource]="calculatedSourceList"
                        [displayMemberPath]="'display'"
                        [selectedValuePath]="'value'"
                        (ngModelChange)="onCalculatedSourceChanged()"
                    ></wj-combo-box>
                    <small class="form-text text-muted">Optional. When set, quarterly values are computed from a report. Cannot be combined with a source metric.</small>
                </div>
            </div>
        </div>

        @if (hasMetricSelected) {
            <div class="row">
                <div class="col-12">
                    <div class="form-group">
                        <label for="aggregation">Quarter Rollup</label>
                        <wj-combo-box
                            id="aggregation"
                            [(ngModel)]="target.aggregation"
                            name="aggregation"
                            [itemsSource]="aggregationList"
                            [displayMemberPath]="'display'"
                            [selectedValuePath]="'value'"
                        ></wj-combo-box>
                        <small class="form-text text-muted">How weekly metric values are combined into a quarterly result.</small>
                    </div>
                </div>
            </div>
        }
    </div>
    <div class="modal-footer">
        <button id="btnSave" type="submit" class="btn btn-primary" (click)="save()" [disabled]="form.invalid || isSaving">
            @if (isSaving) {
                <span><fa-icon [icon]="faSpinner" [animation]="'spin'"></fa-icon>&nbsp;Saving</span>
            } @else {
                <span>Save</span>
            }
        </button>
        <button id="btnCancel" type="button" class="btn btn-secondary" (click)="cancel()" [disabled]="isSaving">Cancel</button>
    </div>
</form>
